import { projectsState } from './projects.state';
import { projectsActions } from './projects.actions';
import { projectsMutations } from './projects.mutations';
import { projectsGetters } from './projects.getters';
import { Module } from 'vuex';
import { RootState } from '@/store/store';
import { ProjectsState } from './types/projects.types';

export default {
  namespaced: true,
  state: projectsState,
  getters: projectsGetters,
  actions: projectsActions,
  mutations: projectsMutations,
} as Module<ProjectsState, RootState>;
